import { useState } from "react";

export default function InvoiceStatusFilter({ setFilter, invoiceCounts }) {
  // local
  const [active, setActive] = useState("in_progress");

  const handleClick = (s) => {
    setActive(s);
    setFilter(s);
  };
  
  return invoiceCounts && (
    <div className="invoice-filter">
      <nav>
        <button
          key={"in_progress"}
          className={active === "in_progress" ? "active" : ""}
          onClick={() => handleClick("in_progress")}
        >
          {invoiceCounts.pending !== 0
            ? `In Progress ${invoiceCounts.pending}`
            : "In Progress"}
        </button>
        <button
          key={"approved"}
          className={active === "approved" ? "active" : ""}
          onClick={() => handleClick("approved")}
        >
          {invoiceCounts.approved !== 0
            ? `Approved ${invoiceCounts.approved}`
            : "Approved"}
        </button>
        <button
          key={"paid"}
          className={active === "paid" ? "active" : ""}
          onClick={() => handleClick("paid")}
        >
          Paid
        </button>
        <button
          key={"disputed"}
          className={active === "disputed" ? "active" : ""}
          onClick={() => handleClick("disputed")}
        >
          {invoiceCounts.disputed !== 0
            ? `Disputed ${invoiceCounts.disputed}`
            : "Disputed"}
        </button>
      </nav>
    </div>
  );
}
